import React, { useEffect } from "react";
import utils from "../../../../utils";
import CustomView from "../../../../components/CustomView";
import TitleLine from "../../../../components/TitleLine";
import "./index.scss";
import {
  CustomBadges,
  CustomButton2,
  CustomModal,
  ImageUploader,
} from "../../../../components";
import Context from "../../../../context";
import {
  TICKET_STATUS,
  ticketUserType,
} from "../../../../values/dropdownItems";
import { uploadImage } from "../../../../api/method.post/common";
import ImageViewer from "../../../../components/ImageViewer";
import { useTranslation } from "react-i18next";

const ShowInfoTicket = () => {
  const [message, setMessage] = React.useState<any>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedImages, setSelectedImages] = React.useState<
    { link: string }[]
  >([]);
  const {
    showModal,
    setShowModal,
    selectedTicket,
    replyTicketFunction,
    refetchTickets,
  } = React.useContext(Context.TicketScreen);

  async function onSentTicket() {
    if (!message) return utils.errorHandler(8002);
    // if (message.length <= 10) return utils.errorHandler(8003);
    const photo = selectedImages.map((item) => item.link);
    const result = replyTicketFunction({
      text: message,
      _id: selectedTicket?._id,
      photo,
    });
    if (result) {
      refetchTickets();
      setSelectedImages([]);
      setMessage("");
    }
  }

  async function onUploadImage(imageFile: File) {
    const imagePromise = await uploadImage!(imageFile);
    if (imagePromise?.CODE === 2042)
      setSelectedImages([...selectedImages, imagePromise?.result]);
  }

  useEffect(() => {
    setSelectedImages([]);
    setMessage("");
  }, [selectedTicket]);

  const { t } = useTranslation();

  return (
    <CustomModal
      open={showModal == "SHOW_TICKET"}
      onClose={() => setShowModal("NONE")}
      maxWidth={"39rem"}
      maxHeight={"85vh"}
    >
      <CustomView.Container>
        <CustomView.Row className="ticket-info">
          {/* <TitleLine title={`عنوان : ${selectedTicket?.subject}`} /> */}

          <CustomView.Column small={5} className="ticket-info-item">
            <i className="fas fa-calendar-alt icon" aria-hidden="true"></i>

            <div className="text-wrapper-tiket">
              <div>{t("requestDate")}</div>
              <strong>
                {utils.convertGregorianToJalali({
                  date: selectedTicket?.createdAt,
                  format: " h:m - jYYYY/jMM/jDD",
                })}
              </strong>
            </div>
          </CustomView.Column>
          <CustomView.Column small={5} className="ticket-info-item">
            <i className="fa fa-clock icon" aria-hidden="true"></i>

            <div className="text-wrapper-tiket">
              <div>{t("lastUpdate")}</div>
              <strong>
                {utils.convertGregorianToJalali({
                  date: selectedTicket?.updatedAt,
                  format: " h:m - jYYYY/jMM/jDD",
                })}
              </strong>
            </div>
          </CustomView.Column>
          <CustomView.Column small={5} className="ticket-info-item">
            <i className="fa fa-user icon" aria-hidden="true"></i>

            <div className="text-wrapper-tiket">
              <div>{t("Applicant")} </div>
              <strong>
                {t(
                  ticketUserType?.find(
                    (userTypeItem) => userTypeItem._id === selectedTicket?.type
                  )?.name as string
                )}{" "}
                (
                {selectedTicket?.user?.firstName +
                  " " +
                  selectedTicket?.user?.lastName}
                )
              </strong>
            </div>
          </CustomView.Column>
          <CustomView.Column small={5} className="ticket-info-item">
            <i className="fas fa-lightbulb icon" aria-hidden="true"></i>

            <div className="text-wrapper-tiket">
              <div>{t("status")}</div>

              <CustomBadges
                type={
                  selectedTicket?.status === "IN_PROGRESS"
                    ? "warning"
                    : selectedTicket?.status === "CLOSED"
                    ? "danger"
                    : "success"
                }
                title={t(
                  TICKET_STATUS.find(
                    (item) => item?._id === selectedTicket?.status
                  )?.name as string
                )}
              />
            </div>
          </CustomView.Column>
          <CustomView.Column small={11} className="ticket-title">
            <strong> {t("title")} : </strong>{" "}
            <span>{selectedTicket?.subject}</span>
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Container>
      <div className="ticket-response">
        <TitleLine title="ارسال پاسخ" />
        <label>
          <div>{t("text")}</div>
          <textarea
            onChange={(event) => setMessage(event.target.value)}
            value={message}
          ></textarea>
        </label>
        <div className="images-container">
          {selectedImages?.map((item) => (
            <ImageUploader
              defaultImage={item}
              setImage={() => setSelectedImages([...selectedImages, item])}
              uploadImage={(event: any) => onUploadImage(event)}
              label=""
              onRemoveImage={(image: string) =>
                setSelectedImages(
                  selectedImages.filter((item) => item?.link !== image)
                )
              }
            />
          ))}
          <ImageUploader
            defaultImage={undefined}
            setImage={() => false}
            uploadImage={(event: any) => onUploadImage(event)}
            label=""
          />
        </div>

        <div className="send-button">
          <CustomButton2
            isLoading={isLoading}
            title={t("submit")}
            onClick={onSentTicket}
          />
        </div>
        <TitleLine title={t("tickets")} />
      </div>

      <div className="ticket-conversation">
        <ul className="ticket-conversation-container">
          {selectedTicket?.ticket
            // ?.slice()
            // .reverse()
            .map((ticket: any, index: number) =>
              ticket?.isAdmin ? (
                <li className="ticket-conversation-item question" key={index}>
                  <div className="ticket-conversation-title">
                    <div>{t("senjedExpert")}</div>
                    <div>
                      {utils.convertGregorianToJalali({
                        date: ticket?.selectedTicket,
                        format: " h:m - jYYYY/jMM/jDD",
                      })}
                    </div>
                  </div>
                  <div className="ticket-conversation-body">
                    {ticket?.text}
                    <div className="response-images-container">
                      {ticket?.photo?.map((item: string) => (
                        <div>
                          <ImageViewer imageUrl={item} />
                        </div>
                      ))}
                    </div>
                  </div>
                </li>
              ) : (
                <li className="ticket-conversation-item answer">
                  <div className="ticket-conversation-title">
                    <div>{`${selectedTicket?.user?.firstName} ${selectedTicket?.user?.lastName}`}</div>
                    <div>
                      {utils.convertGregorianToJalali({
                        date: ticket?.selectedTicket,
                        format: " h:m - jYYYY/jMM/jDD",
                      })}
                    </div>
                  </div>
                  <div className="ticket-conversation-body">
                    <p>{ticket?.text}</p>
                  </div>
                </li>
              )
            )}
        </ul>
      </div>
    </CustomModal>
  );
};

export default ShowInfoTicket;
